import { Box } from "@mui/material";

interface IIconborder {
    children: React.ReactNode;
}

export default function Iconborder({
    children
}: IIconborder): JSX.Element {
    return (
        <Box
            sx={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#E9EFF4" 
            }}
        >
            { children }
        </Box>
    )
}